import { render, staticRenderFns } from "./modal-import-storage.vue?vue&type=template&id=0489b82a&"
import script from "./modal-import-storage.vue?vue&type=script&lang=js&"
export * from "./modal-import-storage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports